import gtm from '@/utils/gtm';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/ui/ef-picture';
import EcoLink from 'eco-design/base/eco-link';
import { Fragment } from 'react';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './index.module.scss';

const App = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');

    const list = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1749784058152/App.png',
            title: t('app_list_title1'),
            desc: t(`app_list_desc1`),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1749784058152/App.png',
            title: t('app_list_title2'),
            desc: t(`app_list_desc2`),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1749784058152/App.png',
            title: t('app_list_title3'),
            desc: t(`app_list_desc3`),
        },
    ];

    const linkList = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1743068342591/platform_1.png',
            desc: t(`app_link_desc1`),
            link: 'https://apps.apple.com/us/app/ecoflow-power-a-new-world/id1506693140#?platform=iphone',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1743068342589/platform_2.png',
            desc: t(`app_link_desc2`),
            link: 'https://play.google.com/store/apps/details?id=com.ecoflow',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1743068342592/platform_3.png',
            desc: t(`app_link_desc3`),
        },
    ];

    const contactList = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1751524222546/contact1.jpg',
            title: t(`app_contact_title1`),
            btn: t(`app_contact_btn1`),
            down: 'https://websiteoss.ecoflow.com/upload/pdf/1756287569065/Ocean%20Pro%20datasheet-%20view%20(1).pdf',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1751524222692/contact2.jpg',
            title: t(`app_contact_title2`),
            btn: t(`app_contact_btn2`),
            herf: 'https://www.ecoflow.com/us/ocean-pro-consultation?utm_source=Productpage&utm_medium=web_push&utm_campaign=OCEANPro_PreOrder2025&utm_content=productpage',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1751524222965/contact3.jpg',
            title: t(`app_contact_title3`),
            btn: t(`app_contact_btn3`),
            herf: 'https://www.reddit.com/r/EcoFlow_OCEAN/s/S4hoMr0A6i',
        },
    ];

    const handleClickApp = (link?: string) => {
        if (!link) return;
        window.open(link, '_blank');
    };

    async function downloadCrossOriginFile(url: string, filename: string) {
        const res = await fetch(url, { mode: 'cors' }); // 或 'no-cors' 会限制 Blob
        const blob = await res.blob();

        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
    }

    const handleClickContact = (item: (typeof contactList)[number]) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'jump_button',
            position: 'Inpage',
            button_name: `${item.title}_${item.btn}`,
            url: item.down || item.herf,
        });

        if (item.down) {
            downloadCrossOriginFile(item.down, 'Ocean Pro datasheet_View.pdf');
        } else {
            window.open(item.herf, '_blank');
        }
    };

    return (
        <Fragment>
            <div className={`${styles.app} GtmModuleData-section`} data-section-id={styles.app} data-section-title={t(`app_title`)}>
                <div className="content">
                    <div className="text-container">
                        <h2>{t(`app_title`)}</h2>
                        <p className="intro">{t(`app_intro`)}</p>
                        <div className="list">
                            {list.map((item) => (
                                <div className="item" key={item.title}>
                                    <EFPicture src={item.img} alt={item.title} className="icon" />
                                    <h4>{item.title}</h4>
                                    <p>{item.desc}</p>
                                </div>
                            ))}
                        </div>
                        <div className="link-wrapper">
                            {linkList.map((item, index) => (
                                <Fragment key={item.desc}>
                                    <div className="link-item" onClick={() => handleClickApp(item?.link)}>
                                        <EFPicture src={item.img} alt={item.desc} className="img" />
                                        <p>{item.desc}</p>
                                    </div>
                                    {linkList.length - 1 !== index && <p className="line" />}
                                </Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.contact}>
                <div className="content pc">
                    {contactList.map((item) => (
                        <div key={item.title} className="item">
                            <div className="text-wrapper">
                                <h3>{item.title}</h3>
                                <a onClick={() => handleClickContact(item)}>
                                    {item.btn}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M7.5 5L12.5 10L7.5 15" stroke="#477BEA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </a>
                            </div>
                            <div className="img-wrapper">
                                <EFPicture src={item.img} alt={item.title} className="img" />
                            </div>
                        </div>
                    ))}
                </div>

                <div className="content h5">
                    <Swiper
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Pagination]}
                        className="contact-swiper"
                        slidesPerView="auto"
                        grabCursor
                        spaceBetween={16}
                    >
                        {contactList.map((item) => (
                            <SwiperSlide key={item.title} className="item">
                                <div className="text-wrapper">
                                    <h3>{item.title}</h3>
                                    <a onClick={() => handleClickContact(item)}>
                                        {item.btn}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M7.5 5L12.5 10L7.5 15" stroke="#477BEA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </a>
                                </div>
                                <div className="img-wrapper">
                                    <EFPicture src={item.img} alt={item.title} className="img" />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                <div className="footer">
                    <EcoLink className="more-btn" href={`https://homebattery.ecoflow.com/us/become-our-partner`} target="_black">
                        {t('btn')}
                    </EcoLink>
                </div>
            </div>
        </Fragment>
    );
};

export default App;
